import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import BasicLayout from './BasicLayout';
import CancelButton from './CancelButton';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

class Idle extends React.Component {

  state = {
    countDown: 15
  };

  componentDidMount() {
    this.idleTimeout = setTimeout(this.countdown, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.idleTimeout);
  }

  countdown = () => {
    if (this.state.countDown > 1) {
      this.setState({ countDown: this.state.countDown - 1 });
      this.idleTimeout = setTimeout(this.countdown, 1000);
    }
    else this.props.logOut();
  };

  render() {

    const { classes } = this.props;

    return (
      <BasicLayout>
        <Dialog
          maxWidth="md"
          fullWidth
          classes={{
            paper: classes.paper,
            paperWidthMd: classes.smallDialog
          }}
          open={true}
          onClose={this.exitError}
          aria-labelledby="idleerror-dialog-title">
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <AccessTimeIcon style={{ width: 40, height: 40, marginBottom: 0 }} />
            <DialogTitle
              disableTypography
              className={classes.mainHeading}
              style={{ marginTop: 0, marginBottom: 0, padding: 0 }}
              id="idleerror-dialog-title">Logout Warning</DialogTitle>
            <DialogContent>
              <DialogContentText className={classes.dialogText} style={{marginTop: 0, marginBottom: 24}}>For security, you will be logged out automatically in</DialogContentText>
              <DialogContentText className={classes.mainHeading} style={{ textAlign: 'center' }}>{this.state.countDown} Seconds</DialogContentText>
            </DialogContent>
          </div>
          <div style={{ textAlign: 'center', marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <CancelButton onClick={this.props.logOut}>Log Out Now</CancelButton>
              <PrimaryButton onClick={this.props.keep}>Keep me Logged In</PrimaryButton>
            </div>
          </div>
        </Dialog>
      </BasicLayout>
    );
  }
}

Idle.propTypes = {
  logOut: PropTypes.func.isRequired,
  keep: PropTypes.func.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(Idle);